import { verticalLabel } from "@/lib/verticals";
import { useVerticalSeeds } from "@/hooks/useVerticalSeeds";

/**
 * Small "for X" pill rendered above the hero. Driven by ?v= query param
 * or by a logged-in tenant's target_vertical_slug (resolved upstream).
 */
interface Props {
  slug?: string | null;
}

export function VerticalBadge({ slug }: Props) {
  const { verticals } = useVerticalSeeds();
  const label = verticalLabel(slug, verticals);
  if (!label) return null;
  return (
    <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-primary/30 bg-primary/10 text-[10px] font-mono uppercase tracking-widest text-primary">
      <span className="h-1.5 w-1.5 rounded-full bg-primary dot-pulse" />
      For {label}
    </div>
  );
}
